import { authRoles } from 'app/auth';
import i18next from 'i18next';
import enNavigation from './navigation-i18n/en';
import huNavigation from './navigation-i18n/hu';

i18next.addResourceBundle('en', 'navigation', enNavigation);
i18next.addResourceBundle('hu', 'navigation', huNavigation);

const navigationConfig = [
	{
		id: 'whatIf',
		title: 'Operator',
		translate: 'OPERATOR',
		type: 'group',
		icon: 'apps',
		auth: authRoles.operatorBlock,
		children: [
			{
				id: 'run',
				title: 'What If',
				translate: 'WHATIF',
				type: 'item',
				icon: 'play_arrow',
				url: '/what-if',
				auth: authRoles.whatif
			},
			// {
			// 	id: 'unitOptimizerOverview',
			// 	title: 'Unit Optimizer Overview',
			// 	translate: 'UNITOPTIMIZEROVERVIEW',
			// 	type: 'item',
			// 	icon: 'bar_chart',
			// 	url: '/unit-optimizer-overview',
			// 	auth: authRoles.unitOptimizerOverview
			// },
			// {
			// 	id: 'optimizationPipeline',
			// 	title: 'Optimization Pipeline',
			// 	translate: 'OPTIMIZATIONPIPELINE',
			// 	type: 'item',
			// 	icon: 'device_hub',
			// 	url: '/optimization-pipeline',
			// 	auth: authRoles.optimizationPipeline
			// },
			{
				id: 'optimizationPipeline',
				title: 'Optimization Pipeline',
				translate: 'OPTIMIZATIONPIPELINE',
				type: 'item',
				icon: 'device_hub',
				url: '/optimization-pipeline-v2',
				auth: authRoles.optimizationPipeline
			},
		]
	},
	{
		id: 'expert',
		title: 'Expert',
		translate: 'EXPERT',
		type: 'group',
		icon: 'apps',
		auth: authRoles.expertBlock,
		children: [
			{
				id: 'taskManager',
				title: 'Task Manager',
				translate: 'TASKMANAGER',
				type: 'item',
				icon: 'reorder',
				url: '/task-manager',
				auth: authRoles.taskManager
			},
			{
				id: 'optimizationPipelineLog',
				title: 'Optimization Pipeline Log',
				translate: 'OPTIMIZATIONPIPELINELOG',
				type: 'item',
				icon: 'reorder',
				url: '/optimization-pipeline-log',
				auth: authRoles.optimizationPipelineLog
			},
			{
				id: 'edtDynamicCheck',
				title: 'Edt Dynamic Check',
				translate: 'EDTDYNAMICCHECK',
				type: 'item',
				icon: 'reorder',
				url: '/edt-dynamic-check',
				auth: authRoles.edtDynamicCheck
			},
			{
				id: 'edtDynamicCheckLog',
				title: 'Edt Dynamic Check Log',
				translate: 'EDTDYNAMICCHECKLOG',
				type: 'item',
				icon: 'reorder',
				url: '/edt-dynamic-check-log',
				auth: authRoles.edtDynamicCheckLog
			},
			// {
			// 	id: 'simlutaionMonitor',
			// 	title: 'Simulation Monitor',
			// 	translate: 'SIMULATIONMONITOR',
			// 	type: 'item',
			// 	icon: 'reorder',
			// 	url: '/simulation-monitor',
			// 	auth: authRoles.simulationMonitor
			// },
			// {
			// 	id: 'simlutaionMonitorLog',
			// 	title: 'Simulation Monitor Log',
			// 	translate: 'SIMULATIONMONITORLOG',
			// 	type: 'item',
			// 	icon: 'reorder',
			// 	url: '/simulation-monitor-log',
			// 	auth: authRoles.simulationMonitorLog
			// },
			{
				id: 'piWriter',
				title: 'PI Writer',
				translate: 'PI_WRITER',
				type: 'item',
				icon: 'reorder',
				url: '/pi-writer',
				auth: authRoles.piWriter
			},
			{
				id: 'piWriterLog',
				title: 'PI Writer Log',
				translate: 'PI_WRITER_LOG',
				type: 'item',
				icon: 'reorder',
				url: '/pi-writer-log',
				auth: authRoles.piWriterLog
			},
			{
				id: 'opcDaWriter',
				title: 'OPC DA Writer',
				translate: 'OPC_DA_WRITER',
				type: 'item',
				icon: 'reorder',
				url: '/opc-da-writer',
				auth: authRoles.opcDaWriter
			},
			{
				id: 'opcDaWriterLog',
				title: 'OPC DA Writer Log',
				translate: 'OPC_DA_WRITER_LOG',
				type: 'item',
				icon: 'reorder',
				url: '/opc-da-writer-log',
				auth: authRoles.opcDaWriterLog
			},
			{
				id: 'unitOptimizer',
				title: 'Unit Optimizer',
				translate: 'UNITOPTIMIZER',
				type: 'item',
				icon: 'reorder',
				url: '/unit-optimizer',
				auth: authRoles.unitOptimizer
			},
			{
				id: 'unitOptimizerLog',
				title: 'Unit Optimizer Log',
				translate: 'UNITOPTIMIZERLOG',
				type: 'item',
				icon: 'reorder',
				url: '/unit-optimizer-log',
				auth: authRoles.unitOptimizerLog
			},
			{
				id: 'modelValidation',
				title: 'Model Validation',
				translate: 'MODELVALIDATION',
				type: 'item',
				icon: 'reorder',
				url: '/model-validation',
				auth: authRoles.modelValidation
			},
			{
				id: 'modelValidationLog',
				title: 'Model Validation Log',
				translate: 'MODELVALIDATIONLOG',
				type: 'item',
				icon: 'reorder',
				url: '/model-validation-log',
				auth: authRoles.modelValidationLog
			},
			{
				id: 'optimizationCase',
				title: 'Optimization Case',
				translate: 'OPTIMIZATIONCASE',
				type: 'item',
				icon: 'reorder',
				url: '/optimization-case',
				auth: authRoles.optimizationCase
			},
			{
				id: 'optimizer',
				title: 'Optimizer',
				translate: 'OPTIMIZER',
				type: 'item',
				icon: 'reorder',
				url: '/optimizer',
				auth: authRoles.optimizer
			},
			{
				id: 'optimizerLog',
				title: 'Optimizer Log',
				translate: 'OPTIMIZERLOG',
				type: 'item',
				icon: 'reorder',
				url: '/optimizer-log',
				auth: authRoles.optimizerLog
			},
			{
				id: 'outlierDetector',
				title: 'Outlier Detector',
				translate: 'OUTLIERDETECTOR',
				type: 'item',
				icon: 'reorder',
				url: '/outlier-detector',
				auth: authRoles.outlierDetector
			},
			{
				id: 'whatifExpert',
				title: 'What-If',
				translate: 'WHATIF',
				type: 'item',
				icon: 'reorder',
				url: '/what-if-expert',
				auth: authRoles.whatifExpert
			},
			{
				id: 'transformer',
				title: 'Transformer',
				translate: 'TRANSFORMER',
				type: 'item',
				icon: 'reorder',
				url: '/transformer',
				auth: authRoles.transformer
			},
			{
				id: 'aspect',
				title: 'Aspect',
				translate: 'ASPECT',
				type: 'item',
				icon: 'reorder',
				url: '/aspect',
				auth: authRoles.aspect
			},
			{
				id: 'dataset',
				title: 'Dataset',
				translate: 'DATASET',
				type: 'item',
				icon: 'reorder',
				url: '/dataset',
				auth: authRoles.dataset
			},
			{
				id: 'measurement',
				title: 'Measurement',
				translate: 'MEASUREMENT',
				type: 'item',
				icon: 'reorder',
				url: '/measurement',
				auth: authRoles.measurement
			}
		]
	},
	{
		id: 'tech',
		title: 'Tech',
		translate: 'TECH',
		type: 'group',
		icon: 'apps',
		auth: authRoles.techBlock,
		children: [
			{
				id: 'model',
				title: 'Model',
				translate: 'MODEL',
				type: 'item',
				icon: 'change_history',
				url: '/model',
				auth: authRoles.model
			},
			{
				id: 'driver',
				title: 'Driver',
				translate: 'DRIVER',
				type: 'item',
				icon: 'device_hub',
				url: '/driver',
				auth: authRoles.driver
			},
			{
				id: 'driverLog',
				title: 'Driver Log',
				translate: 'DRIVERLOG',
				type: 'item',
				icon: 'timeline',
				url: '/driver-log',
				auth: authRoles.driverLog
			},
			{
				id: 'piMeasurementReader',
				title: 'PI Measurement Reader',
				translate: 'PI_MEASUREMENT_READER',
				type: 'item',
				icon: 'category',
				url: '/pi-measurement-reader',
				auth: authRoles.piMeasurementReader
			},
			{
				id: 'labConnection',
				title: 'Lab Connection',
				translate: 'LAB_CONNECTION',
				type: 'item',
				icon: 'category',
				url: '/lab-connection',
				auth: authRoles.labConnection
			},
			{
				id: 'labMeasurementReader',
				title: 'Lab Measurement Reader',
				translate: 'LAB_MEASUREMENT_READER',
				type: 'item',
				icon: 'category',
				url: '/lab-measurement-reader',
				auth: authRoles.labMeasurementReader
			},
			{
				id: 'measurementUnit',
				title: 'Mértékegység',
				translate: 'MEASUREMENT_UNIT',
				type: 'item',
				icon: 'category',
				url: '/measurement-unit',
				auth: authRoles.measurementUnit
			},
			{
				id: 'pictogram',
				title: 'Pictogram',
				translate: 'PICTOGRAM',
				type: 'item',
				icon: 'image',
				url: '/pictogram',
				auth: authRoles.pictogram
			}
		]
	},
	{
		id: 'notifications',
		title: 'notifications',
		translate: 'NOTIFICATION',
		type: 'group',
		icon: 'apps',
		auth: authRoles.notificationsBlock,
		children: [
			{
				id: 'notification',
				title: 'Értesítések',
				translate: 'NOTIFICATION',
				type: 'item',
				icon: 'notifications',
				url: '/notification',
				auth: authRoles.notifications
			}
		]
	},
	{
		id: 'users',
		title: 'users',
		translate: 'USER',
		type: 'group',
		icon: 'apps',
		auth: authRoles.usersBlock,
		children: [
			{
				id: 'user-list',
				title: 'Hozzáférés',
				translate: 'USER_LIST',
				type: 'item',
				icon: 'person',
				url: '/user',
				auth: authRoles.userAccount
			},
			// {
			// 	id: 'dashboard-role',
			// 	title: 'Jogkör',
			// 	translate: 'DASHBOARD_ROLE',
			// 	type: 'item',
			// 	icon: 'perm_identity',
			// 	url: '/dashboard-role',
			// 	auth: authRoles.userRole
			// },
			{
				id: 'user-group',
				title: 'Szerepkör',
				translate: 'USER_GROUP',
				type: 'item',
				icon: 'person',
				url: '/user-group',
				auth: authRoles.userGroup
			},
		]
	}
];

export default navigationConfig;
